import Vue from 'vue';
import BzbsApi from '@/service/BzbsApi.js';
import { AddressListModel } from './config/AddressListModel';

/**
 * @method apiGetConfig
 * @method apiGetBlob
 */

 export default {
    config: function() {
        return Vue.bzbsConfig;
    },

    apiGetAddressList: function (token) {
        var strUrl = Vue.bzbsConfig.bzbs_url + "/profile/me/addresses";
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsGet(strUrl, token, null).then((response) => {
                var addressList = [];
                for (var i of response.data) {
                    var addr = new AddressListModel();
                    addr.setValueFormApi(i);
                    addressList.push(addr);
                }
                resolve(addressList);
            }).catch((error) => {
                reject(error);
            });
        });
    },

    apiAddAddress: function (token, params) {
        params.app_id = this.config().app_id
        
        var strUrl = Vue.bzbsConfig.bzbs_url + "/profile/me/address";
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsPost(strUrl, token, params, null, null).then((response) => {
                resolve(response.data);
            }).catch((error) => {
                reject(error);
            });
        });
    },

    apiUpdateAddress: function (strBzbsToken, params) {
        params.app_id = this.config().app_id
        var strUrl = Vue.bzbsConfig.bzbs_url + "/profile/me/address";
        return BzbsApi.connectBzbsPost(strUrl, strBzbsToken, params, null, null);
    },

    apiDeleteAddress: function (token, key) {
        var params = {
            app_id: this.config().app_id,
            key: key,
        };

        var strUrl = Vue.bzbsConfig.bzbs_url + '/profile/me/address';
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsDelete(strUrl, token, params).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        });
    },
 }